import {
  logger,
  PanelActionOutcome,
  ActionGesture,
  PanelRegion,
  PanelLaunchMethod,
} from "@mwt/web-js-telemetry";

import {
  ScenarioName,
  ScenarioType,
  ModuleName,
  ModuleSummary,
  PanelType,
} from "../../telemetry/utils/constants";

export function logAudioTestResult(success: boolean) {
  logger.logPanelActionEvent({
    actionScenario: ScenarioName.AudioTestSurvey,
    actionScenarioType: ScenarioType.AudioTest,
    actionGesture: ActionGesture.Click,
    actionOutcome: PanelActionOutcome.None,
    moduleName: success
      ? ModuleName.AudioTestResultsClearButton
      : ModuleName.AudioTestResultsUnclearButton,
    moduleSummary: success
      ? ModuleSummary.AudioTestClear
      : ModuleSummary.AudioTestUnclear,
    panelType: PanelType.AudioTest,
    panelLaunchMethod: PanelLaunchMethod.UserInitiated,
    panelRegion: PanelRegion.Main,
    panelUri: window.location.pathname,
  });
}
